<template>
    <el-tooltip :disabled="isShowTooltip" popper-class="myShadowTooltip" effect="dark" placement="top" :open-delay="500">
        <div @mouseenter="enterEvents" class="tooltip-box">
            <slot />
        </div>
        <template slot="content">
            <slot name="contentBox">{{ toolTipContent }}</slot>
        </template>
    </el-tooltip>
</template>

<script>
export default {
    data () {
        return {
            toolTipContent:'',
			isShowTooltip: false
		}
    },
    props: {
        content: {
            type: String,
            default: "",
        },
	},
    components: {},
    computed: {},
    created() {
        this.toolTipContent=this.content
    },
    mounted() {
    },
    methods: {
        enterEvents(e) {
            //console.log(e)
			let tableContentBoxWidth = e.target.getBoundingClientRect().width;
			let tableContentWidth = this.getElementTextWidth(e.target);
			if (tableContentWidth > tableContentBoxWidth) {
				this.isShowTooltip = false;
			}else{
				this.isShowTooltip = true
			}
		},
		getElementTextWidth(el) {
			const range = new Range();
			range.selectNodeContents(el);
			const width = range.getBoundingClientRect().width;
			return width
		}
    },
}

</script>
<style scoped lang='less'>
.tooltip-box{
    flex:1;
    width: 0;
	white-space: nowrap;
    word-break: break-all;
	overflow: hidden;
	text-overflow: ellipsis;
    text-align: left;
    max-width: 932px;
}
</style>